import React, { useEffect } from "react";
import { clearBalances, getBalances } from "../../store/global/getBalances";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Config, WagmiConfig } from "wagmi";
import { bootstrapWagmi } from "../../utils/bootstrapWagmi";
import { SUPPORTED_NETWORKS } from "../../types/network";
import { getAllowances } from "../../store/global/getAllowances";
import "@rainbow-me/rainbowkit/styles.css";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { Disclaimer } from "./Discalimer";
import { useBebopTheme } from "../../hooks/useBebopTheme";
import { getPermit2Allowances } from "../../store/global/getPermit2Allowance";

export interface Web3Props {
  children: React.ReactNode;
}

const wagmiConfig: Config = bootstrapWagmi();
export const Web3: React.FC<Web3Props> = ({ children }) => {
  const bebopTheme = useBebopTheme();
  const address = GlobalStore.useState(s => s.address);
  const network = GlobalStore.useState(s => s.network);
  const tokens = GlobalStore.useState(s => s.tokens);

  /**
   * Load token balances after wallet is connected
   */
  useEffect(() => {
    if (address && tokens) {
      void getBalances
        .run({ address: address as `0x${string}`, tokenMetadata: tokens, chain: network })
        .then(res => {
          if (!res.error) {
            console.log(`Balances`);
            console.warn(res.payload);
          }
        })
        .catch(err => {
          console.error(err);
        });
      void getAllowances
        .run({ address: address as `0x${string}`, tokenMetadata: tokens })
        .then(res => {
          if (!res.error) {
            console.log(`Allowances`, res.payload);
          }
        });
      void getPermit2Allowances
        .run({ address: address as `0x${string}`, tokenMetadata: tokens })
        .then(res => {
          if (!res.error) {
            console.log(`Permit2 Allowances`, res.payload);
          }
        });
    } else {
      clearBalances();
    }
  }, [address, network, tokens]);

  return (
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider
        chains={SUPPORTED_NETWORKS}
        theme={bebopTheme}
        appInfo={{
          disclaimer: Disclaimer,
        }}
      >
        {children}
      </RainbowKitProvider>
    </WagmiConfig>
  );
};
